// extracted by mini-css-extract-plugin
export default {"dashboard":"AdminDashboard_dashboard__G5xhb","dashboard-display":"AdminDashboard_dashboard-display__Hkrfi"};